import { render, staticRenderFns } from "./CaseIndustryNav.vue?vue&type=template&id=84184dea"
import script from "./CaseIndustryNav.vue?vue&type=script&lang=js"
export * from "./CaseIndustryNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports